import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles/fonts';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      display: 'flex',
      alignContent: 'center',
      background: 'var(--x-border-filetype)',
      gap: 8,
      boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
      borderRadius: 16,
      padding: [12, 16],
    },
    copyInfoText: {
      color: colors.white,
      fontSize: 16,
      fontWeight: FontWeight.SemiBold,
      lineHeight: '24px',
    },
    closeIcon: {
      cursor: 'pointer',
      marginLeft: 'auto',
    },
    icon: {
      fill: colors.white,
    },
  }),
  {
    name: 'copy-infos-alert',
  },
);

export default useStyles;
